<template>
  <v-card flat class="pa-3 mt-1">
    <v-card-title class="d-flex align-center justify-center py-0">
      <div class="d-flex align-center">
        <v-img
          :src="require(`@/assets/images/logos/logo.png`)"
          max-width="300px"
          alt="logo"
          contain
          class="me-0"
        ></v-img>
      </div>
    </v-card-title>

    <v-card-text class="pt-4">
      <p class="text-h5 text-center mb-2 font-weight-bold">Create New Njangi Group</p>
      <p class="text-center text-body-2 grey--text mb-6">
        Choose the type of Njangi group you want to create
      </p>

      <v-row justify="center">
        <!-- OPTION 1: Standard Njangi -->
        <v-col cols="12" md="5" class="pa-2">
          <v-card
            outlined
            hover
            class="pa-4 group-type-card"
            :class="{ 'selected-card': selectedType === 'standard' }"
            @click="selectType('standard')"
          >
            <div class="text-center">
              <v-icon size="60" color="primary" class="mb-3">
                mdi-calendar-clock
              </v-icon>

              <h3 class="text-h6 mb-2">Standard Njangi</h3>

              <p class="text-body-2 grey--text mb-4">
                Traditional Njangi groups with predefined cycles
              </p>

              <v-divider class="my-3"></v-divider>

              <div class="text-left">
                <p class="text-caption mb-2"><strong>Features:</strong></p>
                <ul class="text-caption grey--text text--darken-1">
                  <li>Daily contributions</li>
                  <li>Weekly contributions (Monday)</li>
                  <li>Monthly contributions</li>
                  <li>Predefined contribution amounts</li>
                  <li>Automatic fee calculation</li>
                </ul>
              </div>

              <v-btn
                block
                color="primary"
                class="mt-4"
                :outlined="selectedType !== 'standard'"
                @click.stop="goToStandardForm"
              >
                <v-icon left small>mdi-check-circle</v-icon>
                Select Standard
              </v-btn>
            </div>
          </v-card>
        </v-col>

        <!-- OPTION 2: Custom Njangi -->
        <v-col cols="12" md="5" class="pa-2">
          <v-card
            outlined
            hover
            class="pa-4 group-type-card"
            :class="{ 'selected-card': selectedType === 'custom' }"
            @click="selectType('custom')"
          >
            <div class="text-center">
              <v-icon size="60" color="orange darken-2" class="mb-3">
                mdi-cog-outline
              </v-icon>

              <h3 class="text-h6 mb-2">Custom Njangi</h3>

              <p class="text-body-2 grey--text mb-4">
                Flexible Njangi groups with custom intervals
              </p>

              <v-divider class="my-3"></v-divider>

              <div class="text-left">
                <p class="text-caption mb-2"><strong>Features:</strong></p>
                <ul class="text-caption grey--text text--darken-1">
                  <li>Custom collection intervals (e.g., every 3 days)</li>
                  <li>Flexible contribution amounts</li>
                  <li>Custom contribution windows</li>
                  <li>Rotation order preserved</li>
                  <li>Advanced scheduling options</li>
                </ul>
              </div>

              <v-btn
                block
                color="orange darken-2"
                class="mt-4"
                :outlined="selectedType !== 'custom'"
                @click.stop="goToCustomForm"
              >
                <v-icon left small>mdi-check-circle</v-icon>
                Select Custom
              </v-btn>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <!-- Informations complémentaires -->
      <v-row justify="center" class="mt-6">
        <v-col cols="12" md="10">
          <v-alert
            type="info"
            outlined
            dense
            icon="mdi-information-outline"
          >
            <strong>Note:</strong> Both types maintain a rotation order for members to collect contributions.
            The main difference is in the collection frequency and flexibility of configuration.
          </v-alert>
        </v-col>
      </v-row>

      <!-- Bouton retour -->
      <v-row justify="center" class="mt-4">
        <v-col cols="12" md="10" class="text-center">
          <v-btn
            text
            color="grey"
            @click="$router.push('/njangi/view/groups')"
          >
            <v-icon left>mdi-arrow-left</v-icon>
            Back to Groups
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      selectedType: null,
    }
  },

  mounted() {
    document.title = "Manager: Njangi | Select Group Type"
  },

  methods: {
    selectType(type) {
      this.selectedType = type
    },

    goToStandardForm() {
      // ✅ Navigation vers le formulaire Standard (votre composant existant)
      this.$router.push({ name: 'njangi.create_group_standard' })
    },

    goToCustomForm() {
      // ✅ Navigation vers le formulaire Custom
      this.$router.push({ name: 'njangi.create_group_custom' })
    },
  },
}
</script>

<style scoped>
.group-type-card {
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid transparent;
  height: 100%;
}

.group-type-card:hover {
  border-color: #1976d2;
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.2);
}

.selected-card {
  border-color: #1976d2 !important;
  background-color: rgba(25, 118, 210, 0.05);
}

ul {
  padding-left: 20px;
  list-style-type: disc;
}

li {
  margin-bottom: 4px;
}
</style>
